import React, { useState } from 'react';

import { Button } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PanelTagsBlock}
 */

const PanelTags = ({
    prevType,
    title,
    text,
    backgroundColor,
    tags,
}) => {
    const [showTags, setShowTags] = useState(false);
    const bgColor = `bg-surface-panel-${backgroundColor}`;
    return (
        <section className={`${bgColor} ${prevType === 'PanelBasicHalfBlock' ||  prevType === 'PanelTagsBlock' ? 'col-wrapper-breakout' : 'col-wrapper-breakout-half'} rounded-lg flex-grow sm:flex-grow-0 w-full sm:w-1/2 relative`}>
            <div className={`${bgColor} w-full h-full rounded-lg col-padding pt-24 pb-16 sm:-mx-4 md:-mx-8`}>
                <h2 className='type-style-sans-h1 w-full relative z-10'>
                    {title}
                </h2>
                {text && (
                    <p className='type-style-sans-h3 mt-8 w-full md:w-5/6 relative z-10'>
                        {text}
                    </p>
                )}
                {tags?.length > 0 && (
                    <div className='mt-24 md:mt-40 relative z-10 flex flex-wrap gap-8'>
                        {tags.map(({tag}, idx) => {
                            if (!showTags && idx > 6) {
                                return null;
                            }
                            return (
                                <Button
                                    as='a'
                                    className='button-outcome'
                                    href={tag.url}
                                    key={tag.id}>
                                    {tag.title}
                                </Button>
                            );
                        })}
                        {!showTags && tags.length > 7 && (
                            <Button
                                as='button'
                                className='button-outcome'
                                onClick={setShowTags.bind(null, true)}>
                                {'...'}
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PanelTags;
